import React from 'react';

import NavigationBar from './NavigationBar';

const Header = props => {
  return <NavigationBar {...props} />;
};

export default Header;
